import colors from './colors';
import fonts from './fonts/index';
import screen from './screen';
import zindex from './z-index';
import fontsV2 from './fonts-v2';
export default {
  colors: colors,
  fonts: fonts,
  screen: screen,
  zindex: zindex,
  fontsV2: fontsV2
};